import React, { createContext, useEffect } from 'react';
import * as userServices from '../services/user.services';
export const UserCheckContext = createContext();

export function UserCheckProvider({ children }) {
    const userCheck = async () => {
        try {
            if (localStorage.getItem("isAuthenticated") === "true") {
              const userData = await userServices.getUserById(
                localStorage.getItem("id"),
                localStorage.getItem("email")
              );
              if (userData && userData.data && userData.data.isActive === false) {
                userServices
                  .Logout(localStorage.getItem("id"))
                  .then((res) => {
                    localStorage.removeItem("isAuthenticated");
                    localStorage.removeItem("token");
                    localStorage.removeItem("email");
                    localStorage.removeItem("id");
                    localStorage.removeItem("role");
                    localStorage.removeItem("name");
                    localStorage.removeItem("avatar");
                    localStorage.removeItem("accessedBooks");
                    localStorage.removeItem("clientIp");
                    window.location.href = "/";
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            }
        } catch (err) {
            console.error('User check failed', err);
        }
    };

    useEffect(() => {
        userCheck(); // Check on initial load
        
        // Check every 5 minutes
        const intervalId = setInterval(() => {
            userCheck();
        }, 300000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    return (
        <UserCheckContext.Provider value={{}}>
            {children}
        </UserCheckContext.Provider>
    );
}
